export default "__VITE_ASSET__DOvTij9a__"